import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthHttpService } from 'AppServices/authentication/auth-http.service';

@Component({
  selector: 'app-alert-dev-env',
  templateUrl: './alert-dev-env.component.html',
  styleUrls: ['./alert-dev-env.component.scss']
})
export class AlertDevEnvComponent implements OnInit {

  public showLocalDevAlert = environment.envName === 'devLocal';
  public localStorageNonProdEndpoint = false;

  constructor(private _authHttp: AuthHttpService) {}

  ngOnInit() {
    this.localStorageNonProdEndpoint = this._authHttp.isAnyEndpointNonProdThroughLocalhost();
  }

}
